import styled from "styled-components"
import { HEADER_HEIGHT } from "@root/common"

const AppStyled = styled.div`
    min-height: calc(100vh - ${HEADER_HEIGHT});
`

export {AppStyled}